import React, { useState, useEffect } from 'react';
import { intervalToDuration, differenceInMilliseconds, differenceInDays } from 'date-fns';
import clsx from 'clsx';
import { getWordForm } from 'utils/getWordForm';
import { Divider } from 'components/Divider';
import s from './CountdownTimer.module.scss';

export interface CountdownTimerProps {
  dateStart?: Date;
  dateEnd: Date;
  className?: string;
}

export function CountdownTimer({ dateStart, dateEnd, className }: CountdownTimerProps) {
  const [remainingTimeMs, setRemainingTimeMs] = useState(() =>
    differenceInMilliseconds(dateEnd, dateStart || new Date())
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setRemainingTimeMs((prevRemainingTimeMs) => {
        // Помогает избежать плавающую дату
        const newRemainingTimeMs = prevRemainingTimeMs - 1000;
        if (newRemainingTimeMs <= 0) {
          clearInterval(interval);
        }
        return newRemainingTimeMs;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [dateEnd]);

  const duration = intervalToDuration({
    start: 0,
    end: remainingTimeMs
  });

  return (
    <div className={clsx(s.CountdownTimer, className)}>
      <div className={s.CountdownTimer__time}>
        {differenceInDays(dateEnd, new Date()) ?? '00'}
        <span>{getWordForm(duration.days ?? 0, ['день', 'дня', 'дней'])}</span>
      </div>
      <Divider className={s.CountdownTimer__divider} />
      <div className={s.CountdownTimer__time}>
        {duration.hours ?? '00'}
        <span>{getWordForm(duration.hours ?? 0, ['час', 'часа', 'часов'])}</span>
      </div>
      <Divider className={s.CountdownTimer__divider} />
      <div className={s.CountdownTimer__time}>
        {duration.minutes ?? '00'}
        <span>{getWordForm(duration.minutes ?? 0, ['минута', 'минуты', 'минут'])}</span>
      </div>
      <Divider className={s.CountdownTimer__divider} />
      <div className={s.CountdownTimer__time}>
        {duration.seconds ?? '00'}
        <span>{getWordForm(duration.seconds ?? 0, ['секунда', 'секунды', 'секунд'])}</span>
      </div>
    </div>
  );
}
